import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface ThemeDeltaRow {
  variable: string;
  label: string;
  before: string;
  after: string;
  changes: string;
  isNew: boolean;
  isRemoved: boolean;
  hasChange: boolean;
}

export interface ThemeUploadData {
  themeName: string;
  version: string;
}

@Component({
  selector: 'app-upload-theme-modal',
  imports: [FormsModule],
  templateUrl: './upload-theme-modal.component.html',
  styleUrl: './upload-theme-modal.component.css',
})
export class UploadThemeModalComponent {
  // Inputs
  deltaRows = input.required<ThemeDeltaRow[]>();
  mode = input.required<'light' | 'dark'>();
  themeName = input<string>('');
  version = input<string>('');

  // Outputs
  modeChange = output<'light' | 'dark'>();
  themeNameChange = output<string>();
  confirm = output<ThemeUploadData>();
  cancel = output<void>();

  // Local state for form fields
  localThemeName: string = '';
  localVersion: string = '';

  constructor() {
    // Initialize local state from inputs (signals are read-only)
    this.localThemeName = this.themeName();
    this.localVersion = this.version();
  }

  /** Check if a value looks like a CSS color */
  isColor(value: string): boolean {
    const v = value.trim();
    return (
      /^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(v) ||
      /^rgba?\s*\(/.test(v) ||
      /^hsla?\s*\(/.test(v)
    );
  }

  onModeChange(newMode: 'light' | 'dark'): void {
    this.modeChange.emit(newMode);
  }

  onThemeNameChange(): void {
    this.themeNameChange.emit(this.localThemeName);
  }

  onConfirm(): void {
    this.confirm.emit({
      themeName: this.localThemeName,
      version: this.localVersion,
    });
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
